<script>
import commomUtils from '@/mixins/common-utils.js'

export default {
  mixins: [commomUtils()],
  props: {
    button: {
      type: Object,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    computedBackgroundStyles() {
      return {
        'background-color': this.button.style['background-color'],
        opacity: this.button.style.opacity,
      }
    },
    computedBorderStyles() {
      return {
        border: `3px solid ${this.button.style.color}`,
      }
    },
  },
  watch: {
    isSelected() {
      this.$forceUpdate()
    },
  },
  methods: {
    getImgUrl(name) {
      var image = require.context('@assets/images/', false, /\.png$/)
      return image('./' + name + '.png')
    },
    onClickCalification() {
      this.$emit('clickedCalification', this.button)
    },
    imageFallBack(name) {
      this.button.img = this.getImgUrl(name)
      this.$forceUpdate()
    },
  },
}
</script>

<template>
  <div
    :class="$style.container"
  >
    <button
      :class="[$style.calification]"
      :style="button.isSelected && computedBorderStyles"
      @click="onClickCalification(button)"
    >
      <div :class="$style.calificationContent">
        <div :class="$style.calificationContentItems">
          <img
            :class="$style.calificationIcon"
            :src="button.img"
            :alt="button.imgFallback"
            @error="imageFallBack(button.imgFallback)"
          >
          <p
            :class="$style.calificationText"
            :style="{ 'color': button.style.color}"
          >
            {{ button.text }}
          </p>

        </div>
      </div>
    </button>
    <div
      :class="$style.background"
      :style="computedBackgroundStyles"
    />
  </div>
</template>

<style lang="scss" module scoped>
@import '@design';

.container {
  position: relative;
  width: 31%;
  border-radius: 12px;
  transition: transform 0.5s;
}

.calification {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 6rem;
  border-radius: 12px;

  &Content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 95%;
    margin: 0 auto;

    &Items {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      p {
        margin: 0;
      }
    }
  }

  &Text {
    @extend %typography-small;

    margin: 0 0 0 1rem;
    font-weight: 500;
  }

  &Icon {
    max-width: 3rem;
    max-height: 3rem;
  }

  &:focus {
    outline: none;
    transform: scaleX(1.025) scaleY(1.025);
  }
}

.background {
  position: absolute;
  top: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  border-radius: 12px;
}
</style>
